// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import memberApplicationEntity from './entities/member-application.json';
import memberApplicationMenu from '../pages/member-application/menu.json';
import memberApplicationFullForm from '../pages/member-application/forms/full.json';
import memberApplicationContextForm from '../pages/member-application/forms/context.json';
import memberApplicationMiniForm from '../pages/member-application/forms/mini.json';
import memberApplicationLookupForm from '../pages/member-application/forms/lookup.json';
import memberApplicationTableView from '../pages/member-application/views/table.json';
import memberApplicationCardsView from '../pages/member-application/views/cards.json';
import memberApplicationDashboardView from '../pages/member-application/views/dashboard.json';

/** Тип запису «Заява про вступ» зі сторінками пакета: меню, форми та подання з pages/member-application/. */
export const memberApplicationDefinition: IRecordTypeDefinition = {
  ...memberApplicationEntity,
  views: assembleViewSet({
      table: memberApplicationTableView,
      cards: memberApplicationCardsView,
      dashboard: memberApplicationDashboardView,
  }),
  form: memberApplicationFullForm,
  forms: { full: memberApplicationFullForm, context: memberApplicationContextForm, mini: memberApplicationMiniForm, lookup: memberApplicationLookupForm },
  menu: memberApplicationMenu,
} as IRecordTypeDefinition;
